const userSurveyAnswerTypes = {
    SOURCING_CC: 'CC',
    SOURCING_EVAPOR: 'EVAPOR',
    SOURCING_COMP_HNB: 'COMP_HNB',
    SOURCING_POUCHES: 'POUCHES',
    MOTIVATION_HIGH: 'HIGH',
    MOTIVATION_MID: 'MID',
    MOTIVATION_LOW: 'LOW',
    REASON_SOCIAL: 'SOCIAL',
    REASON_TASTE: 'TASTE',
    REASON_AESTHETIC: 'AESTHETIC',
};

export default userSurveyAnswerTypes;
